import { z } from 'zod';
import { apiKeySchema } from '../api-key.types';

export const apiKeyAuthenticationPayload = z.object({
    email: z.string().email(),
    apiKey: apiKeySchema
});

export type ApiKeyAuthenticationPayload = z.infer<typeof apiKeyAuthenticationPayload>;

export const apiKeyAuthenticationResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    accessTokenExpiry: z.number()
});

export type ApiKeyAuthenticationResponse = z.infer<typeof apiKeyAuthenticationResponseSchema>;

export const apiKeyRefreshSessionPayload = z.object({
    refreshToken: z.string()
});

export const apiKeyRefreshSessionResponseSchema = apiKeyAuthenticationResponseSchema.partial({
    accessToken: true,
    refreshToken: true
});
